export { ZoomScaleManager } from './ZoomScaleManager';
export { DataZoomIntegration } from './DataZoomIntegration';
export type { DataZoomConfig, DataZoomLimits } from './DataZoomIntegration';
export type { IZoomScale, IDataZoomAxisConfig, ILevelThreshold } from '../ts-types/zoom-scale';
